<template>
    <div class="detail" v-if="projectDict && data">
        <div class="main-imgs">
            <div class="box">
                <el-image :src="data.pictureUrl[0]"  :preview-src-list="data.pictureUrl"></el-image>
            </div>
            <div class="box">
                <el-image :src="data.pictureUrl[1]"  :preview-src-list="data.pictureUrl"></el-image>
                <el-image  :src="data.pictureUrl[2]"  :preview-src-list="data.pictureUrl"></el-image>
            </div>
            <div class="box">
                <el-image  :src="data.pictureUrl[3]"  :preview-src-list="data.pictureUrl"></el-image>
                <el-image  :src="data.pictureUrl[4]"  :preview-src-list="data.pictureUrl"></el-image>
            </div>
        </div>    
        <div class="content">
            <span>项目编码：{{ data.projectCode }}</span>
            <span>{{ data.projectCategoryName }}</span>
            <span>{{ data.cityName + data.countyName }}</span>
            <span>总额：{{ data.quotationPrice }}万元</span>
            <span>流转保证金：{{ data.margin }}万元</span>
            <a-button type="primary" @click="setOrder(data)">摘单</a-button>
            <a-button type="primary" @click="getVideos">查看视频</a-button>
             <a-button type="primary"  @click="getFiles">查看文件</a-button>
        </div>
        <div class="projectDetail">
            <div class="hiddentext">
                <a-tooltip>
                    <template slot="title">
                     地址：{{ data.cityName + data.countyName  + data.townName + data.villageName}}
                    </template>
                     地址：{{ data.cityName + data.countyName  + data.townName + data.villageName}}
                </a-tooltip>
            </div>
            <div>周边环境：{{ enviromentName.join(',') }}</div>
            <div>出让方：{{ $utils.getVal(projectDict.bg_transferor,data.transferor)}}</div>
            <div>占地面积：{{ data.coverArea }}㎡</div>
            <div>用地面积：{{ data.landArea }}㎡</div>
            <div v-if="data.projectType!='02'">建筑面积：{{ data.buildArea }}㎡</div>
            <div v-if="data.projectType!='02'">结构：{{  $utils.getVal(projectDict.bg_structure,data.structure) }}</div>
            <div v-if="data.projectType!='02'">建筑年份：{{ data.buildYear }}年</div>
            <div>产权证：{{ data.propertyYear=='1'?'有':'无'}}</div>
            <div>测绘：{{ data.mapping=='1'?'已测绘':'未测绘' }}</div>
            <div>评估：{{ data.assess=='1'?'已评估':'未评估' }}</div>
            <div v-if="data.projectType!='02'">经营权证：{{ data.houseAuthority=='1'?'有':'无' }}</div>
            <div>使用年限：{{ data.restYear }}年</div>
            <div>项目状态：{{ $utils.getVal(projectDict.bg_house_state,data.houseState) }}</div>
            <div v-if="data.orgName">推荐机构：{{ data.orgName }}</div>
        </div>  
        <a-modal title="确认下单？" :visible="visible" :confirmLoading="loading"  cancelText="取消" okText="确定"  @ok="handleOk" @cancel="handleCancel">
            <p>总额： {{ currentItem.quotationPrice }}万元 </p>
            <p>流转保证金：{{ currentItem.margin }}万元</p>
            <p>温馨提示: 生成订单后30分钟内可主动撤单</p>
            <p>请确认是否需要开票:</p>
            <a-radio-group v-model="query.invoiceStatus">
                <a-radio value="0">
                    开票
                </a-radio>
                <a-radio value="1">
                    不开票
                </a-radio>
            </a-radio-group>
        </a-modal>  
        <a-modal title="查看文件" :visible="boxVsile" cancelText="取消" okText="确定"  @ok="handleOkbox" @cancel="handleCancelbox">
            <p v-for="(item,index) in fileList" :key="index" style="cursor:pointer" @click="getFiledetail(item.url)">{{ item.name }}</p>
        </a-modal>
        <videoList ref="videoList"></videoList>
    </div>    
</template>
<script>
export default {
    data(){
        return{
           data:'',
           projectDict:'',
           enviromentName:[],
           visible:false,
           loading:false,
           currentItem:'',
           query:{
                invoiceStatus:'1',
                margin:'',
                quotationId:'',
           },
           fileList:[],
           boxVsile:false
        }  
    },
    created(){
        this.$https.get('/portal/projectDict/list').then(res=>{
                if(res.code == 200){
                    this.projectDict = res.rows[0];
                    this.getBaseInfo(this.$route.query.id)
                }else{
                     this.$message.info(res.msg)
                }
        })
        
    },
    mounted(){
        this.$parent.current = '2';
    },
    methods:{
         handleOkbox(){
            this.boxVsile = false;
        },
        handleCancelbox(){
            this.boxVsile = false;
        },
        getBaseInfo(id){
            this.$https.get(`/portal/index/getProjectQuotationInfoById/${id}`).then(res=>{
                if(res.code == 200){
                    res.rows[0].pictureUrl = res.rows[0].pictureUrl.split(',');
                    res.rows[0].enviroment = res.rows[0].enviroment.split(',');
                    res.rows[0].enviroment.forEach(item=>{
                        this.projectDict.bg_enviroment.forEach(ele=>{
                            if(item == ele.dict_value){
                                this.enviromentName.push(ele.dict_label)
                            }
                        })
                    })
                    this.data = res.rows[0];
                    this.fileList = this.data.fileUrl?this.data.fileUrl.split(','):[];
                }
            })
        },
        setOrder(item){
            this.currentItem = item;
            this.query.margin = item.margin;
            this.query.quotationId = item.id;
            this.visible = true;   
        },
        handleOk(){
            if(!this.query.invoiceStatus){
               this.$message.info('请选择是否需要开票');
               return false
            }
            this.loading = true;
            this.$https.post('/portal/listing/pickUp',this.query).then(res=>{
                this.loading =false;
                if(res.code == 200){
                    this.$message.success('下单成功');
                    this.visible = false;
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(error=>{
                this.loading = false;
            })
        },
        handleCancel(){
            this.visible = false;
        },
        getVideos(){
            let videoList = [];
                videoList = this.data.videoUrl?this.data.videoUrl.split(','):[];
            if(videoList.length == 0){
                this.$message.info('没有发现视频喔')
            }else{
                this.$refs.videoList.showDialog(videoList)
            }
        },
         getFiles(){
            this.fileList = JSON.parse(this.data.fileUrl);
            if(this.fileList.length>0){
                this.boxVsile = true;
            }else{
                this.$message.info('没有查到文件喔')
            }
        },
        getFiledetail(url){
            window.open(url)
        }
    }
}
</script>

<style lang="less" scoped>
.detail{
      width: 1300px;
      margin: 0 auto;
      .main-imgs{
          display: flex;
          .box{
                border:5px solid #fff;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                &:nth-of-type(1){
                    width: 770px;
                    height: 440px;
                    margin-right:5px;
                    background: coral;
                    .el-image{
                            &:hover{
                                transform:scale(1.2,1.2);
                                transition:All 0.4s ease-in-out;
                                -webkit-transition:All 0.4s ease-in-out;
                                -moz-transition:All 0.4s ease-in-out;
                                -o-transition:All 0.4s ease-in-out;
                            }
                        }
                }
                &:nth-of-type(2){
                    width: 260px;
                    height: 440px;
                    margin-right:5px;
                    background:darkgray;
                    flex-direction: column;
                        .el-image{
                            height: 215px;
                            width: 260px;
                            &:hover{
                                transform:scale(1.2,1.2);
                                transition:All 0.4s ease-in-out;
                                -webkit-transition:All 0.4s ease-in-out;
                                -moz-transition:All 0.4s ease-in-out;
                                -o-transition:All 0.4s ease-in-out;
                            }
                        }
                }
                &:nth-of-type(3){
                    width: 260px;
                    height: 440px;
                    background:darkorange;
                    flex-direction: column;
                       .el-image{
                            height: 215px;
                            width: 260px;
                               &:hover{
                                    transform:scale(1.2,1.2);
                                    transition:All 0.4s ease-in-out;
                                    -webkit-transition:All 0.4s ease-in-out;
                                    -moz-transition:All 0.4s ease-in-out;
                                    -o-transition:All 0.4s ease-in-out;
                                }
                        }
                }
          }
      }
      .content{
         background: white;
         height: 50px;
         line-height: 50px;
         margin-top:10px;
         padding: 0 10px;
         span{
             margin-right:30px;
         }
         .ant-btn{
             float: right;
             margin-top:9px;
             margin-left:20px;
         }
      }
      .projectDetail{
          display: flex;
          flex-wrap:wrap;
          background: white;
          margin:20px 0;
          padding: 10px;
          div{
              width: 25%;
              line-height: 30px;
          }
      }
       .contentfile{
         background: white;
         line-height: 20px;
         padding: 10px 10px;
         margin-top:10px;
      }
      .hiddentext{
          white-space:nowrap; 
          overflow:hidden;
          text-overflow:ellipsis; 
      }
}
</style>